import { DropDown } from "components/tt-forms/common";
import fileDownload from "js-file-download";
import React, { Component } from "react";
import { Link } from "react-router";

export default class RowItemCanCuCuocThanhTra extends Component {
  handleRemove(indexRemove) {
    this.props.removeVanBanCanCu(indexRemove);
  }
  render() {
    const { vanBanId, coQuanBanHanh, theLoaiVanBan, linhVucVanBan, tenFile, duongDan } =
      this.props.item || [];
    return (
      <tr>
        <td>{this.props.count}</td>
        <td style={{ width: 300, minWidth: 300, maxWidth: 300 }}>
          <DropDown
            className="col-100"
            options={this.props.listDanhMucVanBan}
            keyName='giaTri'
            valueName='ten'
            placeholder="Chọn"
            selectedValue={vanBanId}
            onChange={(e) => {
              this.props.onChange(e.target.value, this.props.count)
            }}
            bindValidator={this}
          />
        </td>
        <td>{coQuanBanHanh || ""}</td>
        <td>{theLoaiVanBan || ""}</td>
        <td>{linhVucVanBan || ""}</td>
        <td>
          <Link
            onClick={fileDownload.bind(this, duongDan, tenFile)}
            className="txt-underline txt-blue"
          >
            {tenFile || ""}
          </Link>
        </td>
        <td>
          <Link className="itt-delete" onClick={this.handleRemove.bind(this, this.props.count - 1)}>Xóa</Link>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/RowItemCanCuCuocThanhTra.jsx